// extracted by mini-css-extract-plugin
module.exports = {"innerContainerStyles":"SuccessScreen_innerContainerStyles__2V_LH","appButtonsBox":"SuccessScreen_appButtonsBox__1Ekrt"};